module.exports = __webpack_public_path__ + "img/a1.59166864.png";